function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Color from 'color';
function lighten(colorString, strength) {
  return Color(colorString).mix(Color('white'), strength).saturate(strength).hex();
}
function darken(colorString, strength) {
  const {
    h
  } = Color(colorString).hsl().object();
  const hueShift = 0 <= h && h <= 180 ? Math.round(-15 + 0.25 * Math.abs(h - 60)) * strength : 180 <= h && h <= 240 ? Math.round(-0.25 * h + 60) * strength : 0;
  return Color(colorString).mix(Color('black'), strength).saturate(strength).rotate(hueShift).hex();
}
function getShadeValue(pos, steps) {
  const medianStep = Math.floor(steps / 2);
  const lightSteps = Math.floor(steps / 2);
  const darkSteps = Math.ceil(steps / 2) - 1;
  const shadeValue = pos < medianStep ? -(1 / (lightSteps + 1)) * (lightSteps - pos) : pos > medianStep ? 1 / (darkSteps + 1) * (pos + (steps % 2 ? 1 : 0) - darkSteps - 1) : 0;
  return shadeValue;
}
function getShadeColor(colorString, pos) {
  const shade = pos < 0 ? lighten : darken;
  return shade(colorString, Math.abs(pos));
}
export function getColorShades(colorString, steps = 16) {
  return Array.from({
    length: steps
  }).fill().map((val, idx) => getShadeValue(idx, steps)).map(pos => getShadeColor(colorString, pos)).reduce((acc, color, idx) => _objectSpread(_objectSpread({}, acc), {}, {
    [(idx + 1) * 100]: color
  }), {});
}
let colors = {
  neutral: getColorShades('#5a5370'),
  green: getColorShades('#34f58e'),
  teal: getColorShades('#00ad9e'),
  blue: getColorShades('#5091f4'),
  purple: getColorShades('#7a5ce5'),
  pink: getColorShades('#ff0080'),
  red: getColorShades('#f74949'),
  orange: getColorShades('#f68b45'),
  yellow: getColorShades('#f7ba34')
};
colors = _objectSpread(_objectSpread({}, colors), {}, {
  primary: colors.pink,
  danger: colors.red,
  warning: colors.orange,
  success: colors.green
});
export default colors;